import { Controller } from "@hotwired/stimulus"
import { AVISO_PENDIENTE, mostrarAviso } from "./autoguardado_controller"

// Va en el contenedor de los flash (#flash) de cada página. Muestra el aviso
// que dejó la página anterior al salir (ej. "Tu borrador quedó guardado…"),
// salvo que se trate de la misma página recargada.
export default class extends Controller {
  connect() {
    let pendiente
    try {
      pendiente = JSON.parse(sessionStorage.getItem(AVISO_PENDIENTE) || "null")
      sessionStorage.removeItem(AVISO_PENDIENTE)
    } catch {
      return
    }
    if (pendiente && pendiente.desde !== location.pathname) mostrarAviso(pendiente)
  }
}
